import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Moment from 'moment'
import { color, spacing, fontSize } from '../theme'

import { IconPencil, IconClose } from '../atoms/Icons'
import { H4 } from '../atoms/Heading'

const TableWrapper = styled.section`
   padding: 0 ${spacing.s};
   display: flex;
   flex-direction: column;
   color: ${color.blueDark};
`

const SchedulesHeader = styled.header`
   font-size: ${fontSize.m},
   font-weight: 700;
   margin: ${spacing.s} 0;
`

const Actions = styled.div`
   display: inline-grid;
   grid-auto-flow: column;
   grid-auto-columns: auto;
   font-size: ${fontSize.s};
   column-gap: ${spacing.sm};
   align-self: flex-end;
   margin-right: -${spacing.sm};
   margin-bottom: ${spacing.xs};
`

const IconButton = styled.button`
   display: inline-flex;
   align-items: center;
   cursor: pointer;
   color: ${color.greyLight};
   transition: color 0.1s linear;
   border: 0;
   background: none;
   padding: 0;

   &:hover {
      color: inherit;
      transition: color 0.0875s ease-out;
   }

   span {
      margin-left: ${spacing.xs};
   }
   svg {
      width: 1.1em;
      height: 1.1em;

      &:not(:only-child) {
         margin-left: calc(${spacing.xs} * 1.5);
      }

      * {
         fill: currentColor;
      }
   }
`

const Table = styled.table`
   font-size: ${fontSize.s};

   td,
   th {
      padding: ${spacing.xs} ${spacing.s};
      text-align: center;
      white-space: nowrap;

      &:first-child {
         text-align: left;
         padding-left: 0;
         width: 100%;
         white-space: initial;
         padding-right: ${spacing.m};
         min-width: 16ch;
      }
   }
`

const formatDate = date => new Moment(new Date(date)).format('dddd, MMM D')

export const CalendarDayTable = ({
   date,
   schedules,
   handleClose,
   handleEdit
}) => (
   <TableWrapper>
      <Actions>
         {handleEdit && (
            <IconButton type="button" onClick={e => handleEdit(date)}>
               <IconPencil width={'18px'} height={'18px'} />
               <span> Edit</span>
            </IconButton>
         )}
         <IconButton type="button" onClick={handleClose}>
            <IconClose width={'18px'} height={'18px'} />
            <span> Close</span>
         </IconButton>
      </Actions>
      <SchedulesHeader>
         <H4>{formatDate(date)}</H4>
      </SchedulesHeader>
      <Table>
         <thead>
            <tr>
               <th>Child</th>
               <th>Drop off</th>
               <th>Pick up</th>
            </tr>
         </thead>
         <tbody>
            {schedules &&
               schedules.map((child, key) => (
                  <tr key={key}>
                     <td>{child.name}</td>
                     <td>{child.dropOff ? child.dropOff : '-'}</td>
                     <td>{child.pickUp ? child.pickUp : '-'}</td>
                  </tr>
               ))}
         </tbody>
      </Table>
   </TableWrapper>
)

CalendarDayTable.propTypes = {
   date: PropTypes.string.isRequired,
   schedules: PropTypes.arrayOf(
      PropTypes.shape({
         /**
          * Child name both first and lastname
          */
         name: PropTypes.string.isRequired,
         /**
          * Start time : AM/PM
          */
         dropOff: PropTypes.string,
         /**
          * End time : AM/PM
          */
         pickUp: PropTypes.string
      })
   ).isRequired,
   handleEdit: PropTypes.func,
   handleClose: PropTypes.func
}

CalendarDayTable.defaultProps = {
   date: null,
   schedules: [
      {
         name: 'First Lastname',
         dropOff: null,
         pickUp: null,
         childOrder: 1
      }
   ],
   handleEdit: undefined,
   handleClose: undefined
}
